import { authorizedAxios } from 'library/axios/apiProvider';

import { Client, UpdateClientBody } from '../../client/types';

export async function updateClient(body: UpdateClientBody): Promise<Client> {
  const { data } = await authorizedAxios().put(`/api/v1/client/`, body);
  return data;
}
